$(document).ready(function () {
  // Toggle the footer when the button is clicked
 if ($('#shopify-section-footer').is(':visible') && $(window).width() <= 768) {
  
    $('#footer-toggle').show();
  }
   else {
    $('#footer-toggle').hide();
  }
  $("#footer-toggle").click(function () {
    $(".footer-fw").slideToggle();
    $(".footer-bottom").slideToggle();
      if ($('.more-info').css('margin-bottom') === '0px') {
    $('.more-info').css('margin-bottom', '70px');
  } else {
    $('.more-info').css('margin-bottom', '0');
  }
      $('#toggleIcon').toggleClass('rotate');
   
  });
});

  // $(document).ready(function() {
  //   var sliderInitialized = false;

  //   $('.image-slider').slick({
  //     dots: true,
  //     arrows: false,
  //     autoplay: true,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     fade: true,
  //     cssEase: 'linear',
  //     adaptiveHeight: true,
  //     infinite: true,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //         }
  //       }
  //     ]
  //   });

  // });
// $(function(){
//   var speed = 300,
//       $li;
  
//   $('.image-slider').on('init', function(slick) {
//     $(slick.target).find('button').append('<span></span>');
    
//     $li = $(slick.target).find('.slick-dots li');
//     animateSpan(0, $li);
//   });

//   // $('.image-slider').slick({
//   //   dots: true,
//   //   autoplay: false,
//   //   autoplaySpeed: speed,
//   //   arrows: false,
//   // });
//       $('.image-slider').slick({
//       dots: true,
//       arrows: false,
//       autoplay: false,
//     autoplaySpeed: speed,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       fade: true,
//       cssEase: 'linear',
//       adaptiveHeight: true,
//       infinite: true
//     });
//   $('.image-slider').mouseover(function() {
//         $(this).slick('play')
//     });
//     $('.image-slider').mouseout(function() {
//         $(this).slick('pause')
//     });
  
//   $('.image-slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
//     $li.find('button span').stop(true, true);
//     $li.find('button').removeClass('filled');
    
//     if(currentSlide == 0) {
//       $li.find('button span').css({
//         'transform': 'scaleX(0)',
//         'border-spacing': 0
//       });
//     } else {
//       // всем до текущего слайда назначить класс, чтобы они были заполнены
//       for(var i = 0; i < currentSlide; i++) {
//         $li.eq(i).find('button').addClass('filled');
//       }
      
//       // всем после текущего слайда убрать классы и ширину, чтобы были пустыми
      
//       for(var i = currentSlide + 1; i < $li.length + 1; i++) {
//         $li.eq(i - 1).find('button').removeClass('filled')
//           .find('span').css({
//         'transform': 'scaleX(0)',
//         'border-spacing': 0
//       });
//       }
//     }
    
//     animateSpan(currentSlide, $li);
//   });
  
//   function animateSpan(currentSlide, $li) {
//     var $currentBtn = $li.eq(currentSlide).find('span');
    
//     $currentBtn.animate({  borderSpacing: 1 }, {
//       step: function(now, fx) {
//         $(this).css('transform', 'scaleX('+ now +')');  
//       },
//       duration: speed
//     }, 'linear');
//   }
// })


$(function() {
  var speed = 300,
    $li;

  // Attach the event handlers to a parent element
  $(document).on('init', '.image-slider', function(slick) {
    $(slick.target).find('button').append('<span></span>');

    $li = $(slick.target).find('.slick-dots li');
    animateSpan(0, $li);
  });

  $(document).on('mouseover', '.image-slider', function() {
    $(this).slick('play');
  });

  $(document).on('mouseout', '.image-slider', function() {
    $(this).slick('pause');
  });

  $(document).on('afterChange', '.image-slider', function(event, slick, currentSlide, nextSlide) {
    $li.find('button span').stop(true, true);
    $li.find('button').removeClass('filled');

    if (currentSlide == 0) {
      $li.find('button span').css({
        'transform': 'scaleX(0)',
        'border-spacing': 0
      });
    } else {
      for (var i = 0; i < currentSlide; i++) {
        $li.eq(i).find('button').addClass('filled');
      }

      for (var i = currentSlide + 1; i < $li.length + 1; i++) {
        $li.eq(i - 1).find('button').removeClass('filled')
          .find('span').css({
            'transform': 'scaleX(0)',
            'border-spacing': 0
          });
      }
    }

    animateSpan(currentSlide, $li);
  });

  // Initialize the Slick Slider on the parent element
  $('.image-slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: speed,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'linear',
    infinite: true
  });

  // Function to animate the scaling effect of the spans
  function animateSpan(currentSlide, $li) {
    var $currentBtn = $li.eq(currentSlide).find('span');

    $currentBtn.animate({ borderSpacing: 1 }, {
      step: function(now, fx) {
        $(this).css('transform', 'scaleX(' + now + ')');
      },
      duration: speed
    }, 'linear');
  }
});
// $('.catalog-slider').on('init', function(event, slick) {
//   var $slider = $(slick.$slider);
//   var $slides = $slider.find('.slick-slide');
//   var numVisibleSlides = 2; // Adjust the number of visible slides based on your design

//   // Set the initial position of the slides using CSS
//   $slides.slice(-numVisibleSlides).addClass('initial-position');
// });


 $(document).ready(function() {
        setTimeout(function() {
          $('.grid-products').addClass('loaded_slider');
        }, 100); // Adjust the delay (in milliseconds) as needed
       
      });


$(document).ready(function() {
        setTimeout(function() {
          $('.image-slider').addClass('loaded_slider');
        }, 100); // Adjust the delay (in milliseconds) as needed
       
      });
$(document).ready(function() {
  $('.grid-view_image').hover(
   function() {
      // On hover in
      $(this).siblings('a.btn.wishlist').show();
      $(this).siblings('a.btn.wishlist.addto-wishlist').show();
    },
    function() {
      // On hover out
      $(this).siblings('a.btn.wishlist').hide();
      $(this).siblings('a.btn.wishlist.addto-wishlist').hide();
    }
  );
  // swiper slider initialization
       var swiper = new Swiper('.swiper-container', {
        slidesPerView: 4.5,     // Display three slides at a time
      spaceBetween: 20,     // Add space between slides
      pagination: {
        el: '.swiper-pagination',   // Show pagination dots
        clickable: true            // Allow clicking on dots to navigate
      },
      navigation: {
        nextEl: '',    // No next arrow
        prevEl: ''     // No previous arrow
      }
         
      });
        setTimeout(function() {
          $('#loading-circle-container').addClass('hidden');
          $('.swiper-container').removeClass('hidden');
        }, 500); // Adjust the delay (in milliseconds) as needed
    
     
});

// $(document).ready(function() {
//    $('.feature-banner-slider').slick({
//     dots: false,
//     arrows: false,
//     autoplay: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     fade: true,
//     cssEase: 'linear',
//     infinite: true
//   });
//     setTimeout(function() {
//           $('#loading-circle-container').addClass('hidden');
//           $('.feature-banner-slider').removeClass('hidden');
//         }, 500); // Adjust the delay (in milliseconds) as needed

 


// });

$(document).ready(function(){
    $(document).on('contextmenu', function(e) {
        e.preventDefault();
    });
});
